import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { AppleLoginIcon } from '@stepstone-genesis/icons';
import { useAppleLogin } from '../../../hooks/useAppleLogin.js';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/index.js';
import { authWithAppleThunk, isLoadingSelector } from '../loginWithAppleSlice.js';
import { sendGlobalTrackingThunk } from '../../../core/thunks.js';
import { trackButtonClick } from '../../../tracking/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../../forms/TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
export const AppleButtonComponent = ({}) => {
    const { t } = useTranslation();
    const { initialized } = useAppleLogin();
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(isLoadingSelector);
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const onSignIn = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'apple',
            componentState,
        }));
        dispatch(authWithAppleThunk());
    };
    return initialized ? (_jsx(Button, { "data-testid": "apple-login-btn", as: "button", variant: "secondary", a11yLabel: "Apple button", type: "button", isLoading: isLoading, isFullWidth: true, iconBefore: _jsx(AppleLoginIcon, {}), size: ['medium'], onClick: onSignIn, children: t('loginregistration.login.appleButton') })) : null;
};
//# sourceMappingURL=AppleButtonComponent.js.map